import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import Axios from 'axios'
Vue.use(require('vue-moment'));
import VueYouTubeEmbed from 'vue-youtube-embed'


Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueYouTubeEmbed)
Vue.prototype.$log = console.log.bind(console)
Vue.prototype.$http = Axios;
//Vue.prototype.$http.defaults.withCredentials = true
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer '+token

}

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
